import { Step } from '../../CharitableGiving.meta';

export const STEP_ID: Step = 'dafGrantAmount';

export interface FormValues {
  dafGrantAmount: number | null;
}
